import Image from "@tiptap/extension-image";
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
import Placeholder from "@tiptap/extension-placeholder";
import { Markdown } from "tiptap-markdown";

export const baseExtensions = ({ placeholder = "", collab = false, images = false } = {}) => [
  ...(images ? [Image.configure({ HTMLAttributes: { class: "lf-post-img" } })] : []),
  StarterKit.configure({ heading: { levels: [2, 3, 4] }, ...(collab ? { history: false } : {}) }),
  Link.configure({ openOnClick: false, autolink: true, HTMLAttributes: { rel: "noopener noreferrer nofollow", target: "_blank" } }),
  Placeholder.configure({ placeholder }),
  Markdown.configure({ html: false, tightLists: true, linkify: true, breaks: true, transformPastedText: true }),
];

export const getMarkdown = (editor) => editor?.storage.markdown.getMarkdown() ?? "";
